import Vue from 'vue'

const context = require.context('./', true, /\.js$/)
    // 加载当前目录下的所有js文件
const httpArr = []

context
    .keys()
    .filter(p => p !== './index.js' && p !== './http.js')
    .forEach(path => httpArr.push(context(path).default))

/**
 * 把所有的请求封装成一个对象
 */

Vue.prototype.$sr_api = Object.assign(...httpArr)